import React from 'react'
import { FormGroup, Input, Label } from 'reactstrap'
import { useReportBuilderContext } from '../ReportBuilderContext'

const FieldSelector: React.FC = () => {
  const { fields, requiredFields, selectedFields, toggleField } = useReportBuilderContext()

  return (
    <>
      <p className='fw-semibold text-uppercase mb-2 fs-6'>Fields</p>
      <div style={{ maxHeight: 300, overflowY: 'auto', minWidth: 220 }}>
        {fields.map(field => {
          const required = requiredFields.includes(field.name)
          const checked = required || selectedFields.some(f => f.name === field.name)
          return (
            <FormGroup check key={field.name} className='ms-2'>
              <Input
                type='checkbox'
                id={`field-${field.name}`}
                checked={checked}
                disabled={required}
                onChange={() => toggleField(field.name)}
              />
              <Label check for={`field-${field.name}`}>{field.label}</Label>
            </FormGroup>
          )
        })}
      </div>
    </>
  )
}

export default FieldSelector
